import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  .content-page {
    position: relative;
    background: #fff0e2;

    ol {
      padding-left: 14px;
    }

    .font-red {
      color: ${theme.primaryRed};
    }

    .spin {
      display: flex;
      justify-content: center;
      .anticon-loading {
        font-size: 40px;
        color: ${theme.primaryRed};
      }
    }

    .title-block {
      margin-bottom: 26px;
    }

    .button-submit {
      display: flex;
      justify-content: flex-end;
      margin-top: 50px;
      button {
        width: 140px;
      }
    }

    .step-process-desktop {
      position: absolute;
      right: 15px;
      top: 15px;
      width: 300px;
    }

    .service-container {
      min-height: calc(100vh - 64px);
      height: 100%;
      padding: 40px;
      padding-top: 60px;
      max-width: 900px;
      margin: auto;
      .service-title-block {
        margin-bottom: 35px;
      }
    }

    .left-block {
      min-height: calc(100vh - 64px);
      height: 100%;
      padding: 40px;
      background-color: #fafafa;

      .block {
        padding: 24px;
        width: 100%;
        border-radius: 16px;
        box-shadow: 0 0 5px 2px rgba(217 167 141 / 0.1) !important;
        background-color: ${theme.white};
        margin-bottom: 16px;
      }

      .title-help {
        margin-bottom: 15px;
      }
    }

    .scope-mobile-block {
      padding: 16px;
      background-color: ${theme.white};
      box-shadow: 0 0 5px 2px rgba(217 167 141 / 0.1) !important;
      border-radius: 16px;

      .block {
        margin-bottom: 16px;
      }

      .title-help {
        margin-bottom: 10px;
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .content-page {
      min-height: calc(100vh - 64px);

      .title-block {
        margin-bottom: 26px;
      }

      .step-process-mobile {
        padding: 20px 40px 0 40px;
      }

      .button-submit-mobile {
        padding: 10px 40px;
      }

      .service-container {
        min-height: auto;
        padding: 40px;
        padding-top: 30px;
        max-width: none;
        .service-title-block {
          margin-bottom: 26px;
        }
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .content-page {
      display: flex;
      flex-direction: column;

      .ant-form {
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .service-container {
        flex: 1;
        margin: 0 0 auto 0;
        padding: 20px;
        .service-title-block {
          margin-bottom: 26px;
        }
      }

      .step-process-mobile {
        padding: 20px 20px 0 20px;
      }

      .button-submit-mobile {
        padding: 15px 20px;
        background-color: ${theme.white};
        box-shadow: 0 -6px 25px 0 rgb(0 0 0 / 14%);
      }
    }
  }
`
